import { setUserVerificationHelpModalOpen } from '@perpay-web/components/actions/userVerificationModal';
import { useAnimatedModal } from '@perpay-web/components/base/Modal/useAnimatedModal';
import { useModal } from '@perpay-web/components/base/Modal/useModal';
import { updateUserInfoContextSuccess } from '@perpay-web/fintech/actions/entities/userInfo';
import { useActionObservableCallback } from '@perpay-web/hooks/useActionObservableCallback';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

const useUserVerificationHelpModal = () => {
    const { isModalOpen, setIsModalOpen } = useModal();

    const {
        isAnimatedModalOpen,
        setIsAnimatedModalOpen,
        animatedModalClassName,
    } = useAnimatedModal({
        isModalOpen,
        setIsModalOpen,
    });

    return {
        isAnimatedModalOpen,
        setIsAnimatedModalOpen,
        animatedModalClassName,
    };
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const hook = useUserVerificationHelpModal();

        useActionObservableCallback(
            hookAction$,
            setUserVerificationHelpModalOpen.type,
            (value) => hook.setIsAnimatedModalOpen(value),
        );

        useActionObservableCallback(
            hookAction$,
            updateUserInfoContextSuccess.type,
            () => hook.setIsAnimatedModalOpen(false),
        );

        return <Context.Provider value={hook}>{children}</Context.Provider>;
    };
    return Provider;
};

const [UserVerificationHelpModalProvider, useUserVerificationHelpModalContext] =
    createContextProvider(providerFactory);

export {
    UserVerificationHelpModalProvider,
    useUserVerificationHelpModalContext,
};
